import { render, staticRenderFns } from "./UFDopInfo.vue?vue&type=template&id=3fc2decc&scoped=true"
import script from "./UFDopInfo.vue?vue&type=script&lang=js"
export * from "./UFDopInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2decc",
  null
  
)

export default component.exports